import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import styled from 'styled-components'
import { Row, Col, List, Checkbox, Icon, Collapse } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { greys, font } from 'assets/themes/theme-default'
import { isMobile } from 'react-device-detect'

import { tradeInShape } from '../../shapes'

const { Panel } = Collapse

const Title = styled.h4`
  font-weight: ${font.weight.base};
  font-size: ${font.size.lg};
  margin-top: 20px;
`

const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark1};
`

const ClickableRow = styled(Row)`
  cursor: pointer;
`

const InteriorIcon = styled(SVG)`
  width: 1em;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: bottom;
`
const Design = props => {
  const { tradeIn, setTradeIn, loading, intl } = props
  const { filtersList, vehicle } = tradeIn
  const { designList } = filtersList
  const handleOnChangeSelectionInterior = item => {
    const { interior } = vehicle

    const isSelected = !interior ? false : interior.filter(el => el.id === item.id).length > 0

    let extendedInteriors = interior ? [...interior] : []

    if (!isSelected) {
      extendedInteriors.push(item)
    } else {
      extendedInteriors = interior.filter(el => el.id !== item.id)
    }

    let extendedVehicle = vehicle

    extendedVehicle = {
      ...vehicle,
      interior: extendedInteriors
    }

    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  const renderCheckboxList = item => {
    const interiorSelected = vehicle.interior
    return (
      <ClickableRow
        type="flex"
        style={{ width: '100%' }}
        align="top"
        gutter={16}
        onClick={() => handleOnChangeSelectionInterior(item)}
      >
        <ColDataInput lg={2} xs={3}>
          <Checkbox
            checked={
              !interiorSelected
                ? interiorSelected
                : interiorSelected.filter(el => el.id === item.id).length > 0
            }
          />
        </ColDataInput>
        <ColDataLabel lg={18} xs={21}>
          {item.label}
        </ColDataLabel>
      </ClickableRow>
    )
  }

  const renderInterior = () => {
    const { interior } = designList
    const { leathers, fabrics } = interior
    const minusIcon = <Icon type="minus" />
    const plusIcon = <Icon type="plus" />

    const renderList = dataSource => (
      <List
        loading={loading}
        dataSource={dataSource}
        renderItem={item => <List.Item>{renderCheckboxList(item)}</List.Item>}
      />
    )

    return (
      <>
        {isMobile && (
          <>
            <Title>
              <FormattedMessage id="configurator-design-card-2-title" />
            </Title>
          </>
        )}
        <div>
          {fabrics.length === 0 && leathers.length === 0 && (
            <Collapse
              expandIcon={({ isActive }) => (isActive ? minusIcon : plusIcon)}
              bordered={false}
              expandIconPosition="left"
              style={{ marginBottom: '10px', marginRight: '10px' }}
            >
              <Panel
                header={
                  <>
                    <FormattedMessage id="prewiew-vehicle-price-5" />
                  </>
                }
              >
                {renderCheckboxList({
                  id: 'default',
                  label: intl.formatMessage({ id: 'standard_upholstery' })
                })}
              </Panel>
            </Collapse>
          )}
          {leathers.length > 0 && (
            <Collapse
              expandIcon={({ isActive }) => (isActive ? minusIcon : plusIcon)}
              bordered={false}
              expandIconPosition="left"
              style={{ marginBottom: '10px', marginRight: '10px' }}
            >
              <Panel
                header={
                  <>
                    <InteriorIcon svg={svg.leather} />
                    <FormattedMessage id="configurator-design-card-2-title-1" />
                  </>
                }
              >
                {renderList(leathers)}
              </Panel>
            </Collapse>
          )}
          {fabrics.length > 0 && (
            <Collapse
              expandIcon={({ isActive }) => (isActive ? minusIcon : plusIcon)}
              bordered={false}
              expandIconPosition="left"
              style={{ marginBottom: '10px', marginRight: '10px' }}
            >
              <Panel
                header={
                  <>
                    <InteriorIcon svg={svg.fabric} />
                    <FormattedMessage id="configurator-design-card-2-title-2" />
                  </>
                }
              >
                {renderList(fabrics)}
              </Panel>
            </Collapse>
          )}
        </div>
      </>
    )
  }

  return <>{renderInterior()}</>
}

Design.propTypes = {
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  intl: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired
}

export default injectIntl(Design)
